import { Component } from "react";
import AppDynamicFilterModal from "../../../partials/AppDynamicFilterModal";
import { Button } from "antd";

export class EnquirySearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: {
        page: 1,
      },
      openDrawer: false,
    };
    this.fields = [
      {
        name: "application_product_type",
        label: "Product TYpe",
        type: "select",
        options: _enum.APPLICATION_PRODUCT_TYPE,
      },
      {
        name: "borrower_mobile_number",
        label: "Mobile No.",
        type: "number",
      },
      {
        name: "borrower_first_name",
        label: "Name",
        type: "text",
      },
      {
        name: "application_status",
        label: "Status",
        type: "select",
        options: _enum.APPLICATION_STATUS,
      },
    ];

    this.isPanVerified = this.props.$store?.user?.is_pan_code_verified;
    this.isAadharVerified = this.props.$store?.user?.is_aadhar_verified;
    this.is_agreement_signed = this.props.$store?.user?.is_agreement_signed;
  }

  componentDidMount() {
    // this.getProductTypes();
    const adminPersona =
      this.props?.$store?.user?.role === _enum.ROUTE_PERSONAS.admin;

    if (!adminPersona) {
      console.log(
        this.isPanVerified,
        this.isAadharVerified,
        this.is_agreement_signed
      );
    }
  }

  getProductTypes() {
    this.props.apis.apiGetProductTypes().then((res) => {
      let productType = this.fields.find(
        (o) => o.name == "application_product_type"
      );
      productType.options = res;
    });
  }

  toggleDrawer = () => {
    this.setState((prev) => ({ openDrawer: !prev.openDrawer }));
  };

  closeDrawer = () => {
    this.setState({ openDrawer: false });
  };

  onSearch = (formData) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, false);
  };

  onReset = (formData, reset) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, reset);
  };

  render() {
    let { openDrawer } = this.state;
    return (
      <>
        <div className="d-flex align-items-center justify-content-end">
          <button
            type="button"
            className="btn filter_modal_btn d-flex align-items-center"
            onClick={(...args) => this.toggleDrawer(...args)}
          >
            <i class="fa-solid fa-filter me-2"></i>
            <span>Filters</span>
          </button>
          {this.isPanVerified &&
            this.isAadharVerified &&
            this.is_agreement_signed && (
              <Button
                type="primary"
                className="btn btn-primary"
                htmlType="button"
                onClick={(...args) => this.props.openApplicationModal(...args)}
              >
                Add Lead
              </Button>
            )}
          <AppDynamicFilterModal
            open={openDrawer}
            onClose={this.closeDrawer}
            fields={this.fields}
            onSearch={this.onSearch}
            onReset={this.onReset}
          />
        </div>
      </>
    );
  }
}

export default constore(EnquirySearch);
